import { Printer, FileDown, Share2, Link2, Mail, Facebook, Twitter, Linkedin } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { buildCommunityPdf } from "@/lib/pdf";
import { hoaName } from "@/lib/api";

const btn = "inline-flex items-center gap-2 rounded-full border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0B2150] hover:bg-[#0B2150] hover:text-white transition-colors";

export const ShareActions = ({ community }) => {
  const url = window.location.href;
  const title = `${hoaName(community.name)} - ${community.city}, ${community.state_code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied to clipboard"); } catch { toast.error("Could not copy link"); }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch { /* cancelled */ }
    } else copy();
  };
  const enc = encodeURIComponent;
  const open = (u) => window.open(u, "_blank", "noopener,noreferrer");
  return (
    <div className="flex flex-wrap gap-2 no-print" data-testid="community-action-bar">
      <button className={btn} onClick={() => window.print()} data-testid="community-print-btn"><Printer className="h-4 w-4" aria-hidden />Print</button>
      <button className={btn} onClick={() => buildCommunityPdf(community, url)} data-testid="community-pdf-btn"><FileDown className="h-4 w-4" aria-hidden />PDF</button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={btn} data-testid="community-share-btn"><Share2 className="h-4 w-4" aria-hidden />Share</button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-white">
          <DropdownMenuItem onClick={share} data-testid="share-native"><Share2 className="h-4 w-4 mr-2" />Share…</DropdownMenuItem>
          <DropdownMenuItem onClick={copy} data-testid="share-copy-link"><Link2 className="h-4 w-4 mr-2" />Copy link</DropdownMenuItem>
          <DropdownMenuItem onClick={() => open(`mailto:?subject=${enc(title)}&body=${enc(url)}`)} data-testid="share-email"><Mail className="h-4 w-4 mr-2" />Email</DropdownMenuItem>
          <DropdownMenuItem onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`)} data-testid="share-facebook"><Facebook className="h-4 w-4 mr-2" />Facebook</DropdownMenuItem>
          <DropdownMenuItem onClick={() => open(`https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(url)}`)} data-testid="share-x"><Twitter className="h-4 w-4 mr-2" />X / Twitter</DropdownMenuItem>
          <DropdownMenuItem onClick={() => open(`https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`)} data-testid="share-linkedin"><Linkedin className="h-4 w-4 mr-2" />LinkedIn</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
